import React, { lazy, Suspense, useEffect } from "react";
import "./App.css"
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { ReactNotifications } from 'react-notifications-component'
import { ChangeIsMobile } from "./redux/actions/mainActions"

//mobile
import MobileLoaderComponent from "./app/mobile/components/LoaderComponent/LoaderComponent"
import MobileHomeLayout from "./app/mobile/layouts/HomeLayout/HomeLayout"
import MobileLayout1 from "./app/mobile/layouts/Layout1/Layout1"
import MobileLayout2 from "./app/mobile/layouts/Layout2/Layout2"
import MobileLayout3 from "./app/mobile/layouts/Layout3/Layout3"
import MobilePropertyPage from "./app/mobile/pages/PropertyPage/PropertyPage";
import MobileRealstatePage from "./app/mobile/pages/RealstatePage/RealstatePage";
import MobileSearchPage from "./app/mobile/pages/SearchPage/SearchPage";
import MobileHomePage from "./app/mobile/pages/HomePage/HomePage";
import MobileSearchResidencePage from "./app/mobile/pages/SearchResidencePage/SearchResidencePage";


//desktop
import DesktopLoaderComponent from "./app/desktop/components/LoaderComponent/LoaderComponent"
import DesktopHomeLayout from "./app/desktop/layouts/HomeLayout/HomeLayout"
import DesktopLayout1 from "./app/desktop/layouts/Layout1/Layout1"
import DesktopLayout2 from "./app/desktop/layouts/Layout2/Layout2"
import DesktopLayout3 from "./app/desktop/layouts/Layout3/Layout3"
import DesktopPropertyPage from "./app/desktop/pages/PropertyPage/PropertyPage";
import DesktopRealstatePage from "./app/desktop/pages/RealstatePage/RealstatePage";
import DesktopSearchPage from "./app/desktop/pages/SearchPage/SearchPage";
import DesktopHomePage from "./app/desktop/pages/HomePage/HomePage";
import DesktopSearchResidencePage from "./app/desktop/pages/SearchResidencePage/SearchResidencePage";

const App = () => {
  const dispatch = useDispatch()
  const isRtl = useSelector((state) => state.main.isRtl)
  const isMobile = useSelector((state) => state.main.isMobile)

  const handleWindowSizeChange = event => {

    window.innerWidth <= 770 ? dispatch(ChangeIsMobile(true)) : dispatch(ChangeIsMobile(false))
  };


  useEffect(()=>{
    window.innerWidth <= 770 ? dispatch(ChangeIsMobile(true)) : dispatch(ChangeIsMobile(false))

  },[])
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);

    isRtl ? document.body.dir = 'rtl' : document.body.dir = 'ltr'
  }, [isRtl, window])


  return isMobile ?
  <BrowserRouter>
  <Suspense fallback={<MobileLoaderComponent />}>
    <ReactNotifications />
    <Routes>
      <Route element={<MobileHomeLayout />}>
        <Route
          exact
          path="/"
          element={<MobileHomePage />}
        />
      </Route>

      <Route element={<MobileLayout3 />}>

        <Route
          exact
          path="/search"
          element={<MobileSearchPage />}
        />
      </Route>


      <Route element={<MobileLayout1 />}>
        <Route
          exact
          path="/property"
          element={<MobilePropertyPage />}
        />
        <Route
          exact
          path="/search-property"
          element={<MobileSearchResidencePage />}
        />
      </Route>


      <Route element={<MobileLayout2 />}>
        <Route
          exact
          path="/realstate"
          element={<MobileRealstatePage />}
        />
      </Route>
    </Routes>

  </Suspense>
</BrowserRouter > :
    <BrowserRouter>
      <Suspense fallback={<DesktopLoaderComponent />}>
        <ReactNotifications />
        <Routes>
          <Route element={<DesktopHomeLayout />}>
            <Route
              exact
              path="/"
              element={<DesktopHomePage />}
            />
          </Route>

          <Route element={<DesktopLayout3 />}>

            <Route
              exact
              path="/search"
              element={<DesktopSearchPage />}
            />
          </Route>


          <Route element={<DesktopLayout1 />}>
            <Route
              exact
              path="/property"
              element={<DesktopPropertyPage />}
            />
            <Route
              exact
              path="/search-property"
              element={<DesktopSearchResidencePage />}
            />
          </Route>


          <Route element={<DesktopLayout2 />}>
            <Route
              exact
              path="/realstate"
              element={<DesktopRealstatePage />}
            />
          </Route>
        </Routes>

      </Suspense>
    </BrowserRouter >


}

export default App;
